import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsRequireApplicantApprovalService {
  private readonly _requireApplicantApproval = new BehaviorSubject<boolean>(false);

  readonly requireApplicantApproval$ = this._requireApplicantApproval.asObservable();

  get value(): boolean {
    return this._requireApplicantApproval.getValue();
  }

  update(value: boolean): void {
    this._requireApplicantApproval.next(value);
  }
}